import { type Sport } from "hooks"
import {
  useFilterByTime,
  filterGamesByTime,
} from "@/compositions/events/TimeFilter/TimeFilter"

const useFilteredLeagues = (
  leagues: Sport["leagues"],
  isOvertimeChain?: boolean
): Sport["leagues"] => {
  const { filterByTime } = useFilterByTime()

  const filteredByTime = leagues
    .map(({ games, ...rest }) => {
      const filteredGames = filterGamesByTime(games, filterByTime)

      return {
        ...rest,
        games: isOvertimeChain
          ? filteredGames.filter(game => {
              // check if they have child markets AND valid odds
              return (
                ((game as any).childMarkets &&
                  (game as any).childMarkets.length > 0) ||
                ((game as any).odds && (game as any).odds.length > 0)
              )
            })
          : filteredGames,
      }
    })
    .filter(({ games }) => games.length > 0)

  return filteredByTime
}

export default useFilteredLeagues
